export abstract class BaseConnection {}